export default class GetDirigidoById {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(id) {
    try {
      const result = await this.#repository.getDirigidoById(id)
      return result
    } catch (error) {
      console.error('Error al obtener el dirigido:', error)
      throw error
    }
  }
}
